import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    width: '100%',
    height: '100%',
  },
  noticeCard: {
    background: theme.palette.custom.background.light,
    border: `1px solid ${theme.palette.custom.border.primary}`,
    borderRadius: theme.borderRadius.lg,
    padding: 20,
  },
  balanceInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: 4,
    width: '100%',
    marginTop: 'auto',
  },
  inputAndButton: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    width: '100%',
  },
  skeleton: {
    width: '60px !important',
  },
}));

export default useStyles;
